import { DividerWithText } from "@shared/ui";
import { TranslateLink } from "@shared/ui";
import MedenticAuthEntryPage from "@shared/ui/MedenticAuthEntryPage";
import { EmailIcon, LogoGoogleIcon } from "@medentic/polaris-icons";
import { REGISTER_STEPS, ROUTES } from "@app/config/constants";
import { useTranslation } from "react-i18next";
import { URLLinkBuilder } from "@shared/lib";
import "../styles.scss";

import {
  Button,
  Link,
  BlockStack,
  Text,
  Box,
  InlineStack,
} from "@medentic/polaris-react";

type RegisterSteps = (typeof REGISTER_STEPS)[keyof typeof REGISTER_STEPS];
type RegisterOptionsProps = {
  onSelect: (step: RegisterSteps) => void;
};

function RegisterOptions({ onSelect }: RegisterOptionsProps) {
  const { t, i18n } = useTranslation();
  const locale = i18n.language;
  const termsUrl = URLLinkBuilder.wwwLegal("terms-of-service", locale);
  const privacyUrl = URLLinkBuilder.wwwLegal("privacy", locale);

  return (
    <MedenticAuthEntryPage width="sm" enableAuthRouteRedirect footer={<Box
      paddingBlockStart={"500"}
      paddingBlockEnd={"500"}
      maxWidth="460px"
    >
      <Text as={"p"} alignment="start" tone="subdued">
        <TranslateLink text={t("auth.common.footer.byProceeding", { termsUrl, privacyUrl })} />
      </Text>
    </Box>}>
      <>
        <BlockStack gap="500" inlineAlign="start">
          <Box paddingBlock="200">
            <Text variant="heading2xl" as="h1">
              {t("auth.registration.common.createAccount")}
            </Text>
          </Box>
        </BlockStack>

        <BlockStack gap="300">
          <Box background="bg-fill-secondary" borderRadius="200">
            <div className="wide-button">
              <Button
                size="large"
                fullWidth
                variant="tertiary"
                icon={EmailIcon}
                onClick={() => onSelect(REGISTER_STEPS.FORM)}
              >
                {t("auth.registration.pre.signUpWithEmail")}
              </Button>
            </div>
          </Box>
          <Box background="bg-fill-secondary" borderRadius="200">
            <div className="wide-button">
              <Button
                size="large"
                fullWidth
                variant="tertiary"
                icon={LogoGoogleIcon}
                onClick={() => onSelect(REGISTER_STEPS.GOOGLE_SIGN_UP)}
              >
                {t("auth.registration.pre.signUpWithGoogle")}
              </Button>
            </div>
          </Box>
          <InlineStack align="center" blockAlign="center">
            <DividerWithText text={t("auth.login.or")} />
          </InlineStack>

          <InlineStack gap={"200"} align="center">
            <Text as="p" >
              {t("auth.registration.common.alreadyHaveAccount")}
            </Text>
            <Link url={ROUTES.LOGIN} removeUnderline>{t("auth.registration.common.logIn")}</Link>
          </InlineStack>
        </BlockStack>

      </>
    </MedenticAuthEntryPage>
  );
}

export default RegisterOptions;
